"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enumToDisplayString = enumToDisplayString;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

/*
* Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
* Licensed for non-distributable use to Ergonauts LLC
*/
function enumToDisplayString(str) {
  if (str == null) {
    return null;
  }

  return str.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(' ');
}

;